import { AnnouncementVideoBase } from './AnnouncementVideoBase';
import { createYouTubeHandler } from '../../../MediaController';
import { YouTubeHandler } from '../../../MediaController/Video';
import { toBoolean } from '../../../Utility';
import { AnnouncementWidget } from '../AnnouncementWidget';
import { Log } from '../../../AuxillaryService/Log';
import { YoutubeAsset } from '../../../ReachApiV2/endpoints';

export class AnnouncementYoutube extends AnnouncementVideoBase<YoutubeAsset> {
    protected _playerElementId: string;
    protected _player: YouTubeHandler;

    constructor(
        configuration: YoutubeAsset,
        widget: AnnouncementWidget,
        width: number,
        height: number
    ) {
        super(configuration, widget, width, height);

        this._playerElementId = `youtube_${configuration.announcementId}_widget_${widget.id}`;

        if (!configuration.youtubeLink || configuration.youtubeLink === '') {
            Log.Error(
                `YouTube announcement has invalid link for announcement (id=${this.configuration.announcementId})`
            );
        }

        this._player = createYouTubeHandler({
            youtubeLink: configuration.youtubeLink || '',
            muted: toBoolean(widget.config.mute_videos),
            showSubtitles: Boolean(configuration.enableClosedCaptioning),
            startTime: configuration.videoStartTime,
        });
    }
}
